import { smoother } from "../../base/_gsap-core.js";
import {
   Carousel,
   Autoplay,
   Thumbs,
} from '../../base/_fancyapps';

document.addEventListener('DOMContentLoaded', () => {
   const section = document.querySelector('.hero');
   const carouselEl = section?.querySelector('#carousel-hero');
   const navEl = section?.querySelector('.carousel-nav');
   const counterEl = section?.querySelector('#carousel-counter');

   if (section && carouselEl) {
      const carousel = new Carousel(carouselEl, {
         Autoplay: {
            timeout: 5000,
            autoStart: true,
         },
         Dots: {
            dynamicFrom: 5,
            minCount: 3,
         },
         Navigation: false,
         transition: 'classic',
      }, { Autoplay });

      // Atualiza o contador (ex: 01/15)
      const updateCounter = () => {
         const current = carousel.pages[carousel.page]?.index + 1 || 1;
         const total = carousel.pages.length || 1;

         counterEl.textContent = `${String(current).padStart(2, '0')}/${String(total).padStart(2, '0')}`;
      };

      // Atualiza ao iniciar e ao mudar de slide
      if (counterEl) {
         carousel.on('ready', updateCounter);
         carousel.on('change', updateCounter);
      }

      // Controle dos botões
      if (navEl) {
         navEl.addEventListener('click', (e) => {
            if (e.target.closest('.btn-next')) {
               carousel.slideNext();
            } else if (e.target.closest('.btn-prev')) {
               carousel.slidePrev();
            }
         });
      }
   }
});